/**
 * Select — atom (CES standard)
 * Replicates the client portal's Select: bordered, rounded, orange focus
 * ring. forwardRef for parity with Input.
 */

import { forwardRef, type ReactNode, type SelectHTMLAttributes } from 'react';

export const Select = forwardRef<
  HTMLSelectElement,
  SelectHTMLAttributes<HTMLSelectElement> & { children?: ReactNode }
>(function Select({ className = '', children, ...props }, ref) {
  return (
    <select
      ref={ref}
      className={`border border-gray-300 rounded px-3 py-2 bg-white text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-orange-500 ${className}`}
      {...props}
    >
      {children}
    </select>
  );
});
